<template>
  <div class="d-flex flex-column p-3">
    <div
      class="d-flex justify-content-center w-100"
      style="margin-top: 110px"
      v-if="loadingTable"
    >
      <loading />
    </div>

    <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>
      <div style="position: relative;">
        <div class="d-flex"             
        style="z-index: 10 !important">
          <filtro-bookings-late-arrivals />
          <informacion-general-modal
            :data="dataInformacionGeneral"
            :dataDetalle="dataDetalle"
            :accionesVer="accionesVer"
            :load="load"
            :verDetalleLateArrivals="verDetalleLateArrivals"
            :generarBotonesAccionesVerDetalle="generarBotonesAccionesVerDetalle"
          />
        </div>
      </div>
      <div class="w-100" id="">
        <data-table
          customHeaders
          :headers="headers"
          :data="dataAux"
          :acciones="acciones"
          :max="8"
          paginacion
          buscar
          idtabla="lista_late_arrivals"
          :seleccionar="obtenerFilaSeleccionada"
          :numerador="false"
          exportarExcel
          :btnSpecificZIndex="2"
        />
      </div>
      
    </div>

    <actualizar-late-arrivals-modal
      :data="dataLateArrivalsActualizar"
      :accionesAux="accionesAux"
      :contenedoresItinerario="dataLatePorItinerario"
      :cargarLateArrivalsPorItinerario="cargarLateArrivalsPorItinerario"
      :load="load"
    />
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Componentes
import DataTable from "../../../components/common/DataTable";
import Loading from "../../common/loading";
import InformacionGeneralModal from "../../modals/lineas/booking/late_arrivals/InformacionGeneralModal";
import FiltroBookingsLateArrivals from "../../filtros/lineas/booking/FiltroBookingsLateArrivals";
import ActualizarLateArrivalsModal from "../../modals/lineas/booking/late_arrivals/ActualizarLateArrivalsModal";

// Constantes
import {
  getBookingsLateArrivals,
  deleteBookingsLateArrivals,
  getLateArrivalsPorItinerario,
  getListarDetalleLateArrivals,
} from "../../../constants/lineas";

// Toast
import VueToastify from "vue-toastify";

Vue.use(VueToastify);

export default {
  props: ["data"],
  data() {
    return {
      headers: [
        { title: "ID", width: "30px" },
        { title: "Semana", width: "30px" },
        { title: "POL ETA", width: "140px" },
        { title: "Cliente", width: "50px" },
        { title: "Naviera", width: "50px" },
        { title: "Nave", width: "50px" },
        { title: "POD", width: "50px" },
        { title: "Producto", width: "50px" },
        { title: "N° Booking", width: "50px" },
        { title: "Cantidad", width: "30px" },
        { title: "Cant. Late Arrival", width: "30px" },
        { title: "Cant. Aceptados", width: "30px" },
        { title: "Cant. Rechazados", width: "30px" },
        { title: "Acciones", width: "30px" },
      ],
      acciones: [],
      dataInformacionGeneral: [],
      dataLateArrivalsActualizar: [],
      dataAux: this.data,
      dataLatePorItinerario: [],
      dataDetalle: [],
      accionesAux: [],
      accionesVer: [],
      load: false
    };
  },
  components: {
    DataTable,
    Loading,
    FiltroBookingsLateArrivals,
    ActualizarLateArrivalsModal,
    InformacionGeneralModal,
  },
  computed: {
    ...mapState(["loading", "loadingTable","zIndexModal","zIndexTablaModal"]),
  },
  methods: {
    ...mapActions(["ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetDataBookingsLateArrivals",
      "actionSetVisibleModalEditarLateArrival",
      "actionSetVisibleModalInformacionGeneralLateArrival",
      "actionSetDatatableDetalleLateArrivals",
    ]),
    async generarBotonesAccionesAux() {
      let me = this;

      me.accionesAux = [];
      await this.dataLatePorItinerario.map((item, index) => {
        me.accionesAux.push([
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },
    async generarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataAux.map((item, index) => {
        me.acciones.push([
          {
            icon: "fa fa-search",
            title: "Ver Detalle",
            id: index,
          },
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
      me.ActionSetLoadingTable(false);
    },
    generarBotonesAccionesVerDetalle() {
      this.accionesVer = [];

      this.dataDetalle.map((item, index) => {
        this.accionesVer.push(
          item.data_complementaria.estado !== null
            ? [
                {
                  icon: "fas fa-exclamation-triangle",
                  title: "No hay acciones para este contenedor",
                  id: index,
                },
              ]
            : [
                {
                  icon: "fa fa-check",
                  title: "Confirmar Late Arrival",
                  id: index,
                },
                {
                  icon: "fa fa-ban",
                  title: "Rechazar",
                  id: index,
                },
              ]
        );
      });
    },

    async obtenerFilaSeleccionada(fila) {
      let data_fila = this.data[fila.id];
      let itinerary_id = data_fila.data_complementaria[4];
      let nombre_cliente = data_fila.data[3];
      let id_reserva = data_fila.data[0];
      let itineraryId = data_fila.data_complementaria[4];

      if (fila.accion == "Ver Detalle") {
        this.dataInformacionGeneral = data_fila;

        this.actionSetVisibleModalInformacionGeneralLateArrival(true);

        await this.verDetalleLateArrivals(itinerary_id);

        this.generarBotonesAccionesVerDetalle();
      } else if (fila.accion == "Editar") {
        this.dataLateArrivalsActualizar = data_fila;
        await this.actionSetVisibleModalEditarLateArrival(true);
        await this.cargarLateArrivalsPorItinerario(itinerary_id);
        this.generarBotonesAccionesAux();

      } else if (fila.accion == "Eliminar") {
        
        this.$vToastify.prompt({
             body: `¿Desea eliminar el Late Arrival , ID: ${id_reserva} de ${nombre_cliente}?`,
             answers: {"Sí": true, "No": false}
          }).then(
            (respuesta) => respuesta && this.eliminarLateArrival(itineraryId)
          );

      }
    },
    // Obteneción de Depositos desde la BD
    async cargarLateArrivalsPorItinerario(itinerary_id) {
      this.load = true;
      let { data_table } = await getLateArrivalsPorItinerario(itinerary_id);
              
      const data = (data_table) ? data_table.map( d => ({
        ...d, type : [{ key: 0, type: "textbox" }] 
      })) : [] ;

      this.load = false;
      this.dataLatePorItinerario = data ; 
      this.generarBotonesAccionesAux();
    },

    async verDetalleLateArrivals(itinerary_id) {
      this.load = true;
      let dataDetalleDB = await getListarDetalleLateArrivals(itinerary_id);
      this.dataDetalle = [];
      this.dataDetalle = dataDetalleDB.data_table;
      this.load = false;
    },

    async eliminarLateArrival(id) {
      let sql = await deleteBookingsLateArrivals({ id });

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataBookingsLateArrivalsDB = await getBookingsLateArrivals();

        // Actualizar los datos del dataTable
        this.actionSetDataBookingsLateArrivals(
          dataBookingsLateArrivalsDB.data_table
        );
        this.generarBotonesAcciones();

        this.dataAux = dataBookingsLateArrivalsDB.data_table;

        this.$vToastify.success(
          "Late Arrival eliminado correctamente",
          "¡Realizado!"
        );
      } else {
        console.log("Error");
      }
    },
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
    }, 400);
  },
  watch: {
    data: function (_new) {
      let me = this;
      if (_new) {
        me.dataAux = _new;
        this.generarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
